// Auto-generated at deploy time from SSM /prod-platform/saas/. Do not edit.
export const environment = {
  production: true,
  ALLOW_ANALYTICS: true,
  AUTH_BASE_URL: 'https://api.intelycare.com/auth',
  AUTH_SERVICE_BASE_URL: 'https://api.intelycare.com/authservice',
  DOCUMENT_BASE_URL: 'https://api.intelycare.com/document',
  GOOGLE_KEY: 'AIzaSyCvfsuYeV6GtDthXGiVxnDE-HAex6h6atY',
  ICARE_BASE_URL: 'https://api.intelycare.com/icaredata',
  SHIFT_JAVA_URL: 'https://api.intelycare.com/shiftmanagement',
  STAFF_BASE_URL: 'https://api.intelycare.com/staff',
  USER_BASE_URL: 'https://api.intelycare.com/jwt/user',
  ALLOW_MARKETO: true,
  BACKGROUND_CHECK_URL: 'https://api.intelycare.com/background',
  CLIENTID: '1',
  ISYSTEM_BYPASS_GATEWAY_BASE_URL: 'https://demand.prod.platform.legacy.intelycare.com/isystem',
  LEGACY_HUB_LOGIN: 'https://portal.intelycare.com/hub/views/login.html',
  SCHEDULING_URL: 'https://demand.prod.platform.legacy.intelycare.com',
  SHIFT_BASE_URL: 'https://api.intelycare.com/backend',
  SOCKET_BASE_URL: 'https://socket.prod.platform.legacy.intelycare.com',
  TASK_BASE_URL: 'https://api.intelycare.com/staff/notes',
  INTERNAL_URL: 'https://api.intelycare.com',
  ISYSTEM_BASE_URL: 'https://api.intelycare.com/isystem',
  JOB_BOARD_URL: 'https://intelycare.com/job-board/intelycare-auth-callback',
  SERVICE: 'ISchedule',
  SHIFT_URL: 'https://api.intelycare.com/shift',
};
